import { AppEvent, TrackedEventName } from "@ac-expo/api-types";
import { useWebSocket } from "../context/websocket/websocket.context";

export type TrackingFn = <
  TExec extends (...args: any) => any,
  TName extends TrackedEventName,
  TData,
>(
  eventExecutor: TExec,
  event: AppEvent<TName, TData>
) => ReturnType<TExec>;
type SendAppEventFn = <TData>(event: AppEvent<TrackedEventName, TData>) => void;

const useTracking = () => {
  const { sendMessage } = useWebSocket();

  const sendAppEvent: SendAppEventFn = (event) =>
    sendMessage(event.name, event);

  const track: TrackingFn = (eventExecutor, event) => {
    sendAppEvent(event);
    return eventExecutor();
  };

  return { track };
};

export default useTracking;
